import { useSiteMap } from './withSiteMap';
import { getUrlForLink, MaybeLink } from './getUrlForLink';

export function useUrlForLink(link: MaybeLink) {
	const siteMap = useSiteMap();

	return getUrlForLink(link, siteMap);
}
